(function() {
    'use strict';
    
a3_cabin_reports.factory('MessageFactory', MessageFactory)

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name MessageFactory
    * @description 
    *   Add, Update, Delete and Get Messages.
    * @ngInject
    */
function MessageFactory(GenericService) {
    
        /**
        * Initialize the Message
        * @memberof MessageFactory
        */
		function Message() {
			this.Id = null;
			this.Title = null;
			this.AuthorName = null;
			this.Body = null;
			this.AcType = null;
			this.AirportA = null;
			this.AirportB = null;
			this.Country = null;
			this.FlightDirection = null;
			this.FlightNo = null;
			this.ValidFrom = null;
			this.ValidTo = null;
			this.PositionCP = true;
			this.PositionFA = true;
			this.PositionFO = true;
			this.PositionSA = true;
			this.QueryType = null;
			this.ReadDt = null;
			this.Registration = null;
			this.FeedbackCause = null;
		}
				
		var objType = 'messages';
		var objCallback = Message; 
		
		var service = 
		{  
			fromObjectList : fromObjectList,
			getMessagesFromStorage : getMessagesFromStorage,
			setMessagesToStorage : setMessagesToStorage,
			clearMessagesFromStorage : clearMessagesFromStorage,
			getCountOfUnreadMessages : getCountOfUnreadMessages,
			getMessagesFromIds : getMessagesFromIds,
			getUnreadMessages : getUnreadMessages,
			markReaden : markReaden,
			markReadAsSynched : markReadAsSynched,
			getUnsynchedReadMessages : getUnsynchedReadMessages,
			storeMessagesFromServer : storeMessagesFromServer
		};

        /**
         * Extend an array of Objects from the default message Object
         * @memberof MessageFactory
         * @param {Array} objList  an Array Of messages
         * @returns {Array} messages
         */
		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		}

        /**
         * Get messages
         * @memberof MessageFactory
         * @returns {Array} messages 
         */
		function getMessagesFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Save messages to storage
         * @memberof MessageFactory
         * @param {Array} messages A list of messages
         */
		function setMessagesToStorage(messages) {
			GenericService.saveAll(messages,objType,objCallback);
		}

        /**
         * Remove the messages of  the local storage
         * @memberof MessageFactory
         */
		function clearMessagesFromStorage() {
			GenericService.removeAll(objType,objCallback);
		}

         /**
         * Get count of unread messages
         * @memberof MessageFactory
         * @returns {number} result 
         */
		function getCountOfUnreadMessages() {
			var messages = getMessagesFromStorage();
			if (!messages)
				return 0;

			var result = 0;
			var arrayLength = messages.length;

			for (var i = 0; i < arrayLength; i++) {
				if (!messages[i].ReadDt) {
					result++;
				}
			}

			return result;
		}

        /**
         * Get messages from given ids
         * @memberof MessageFactory
         * @param {Ids} List of Ids
         * @returns {Array} selectedMessages 
         */
		function getMessagesFromIds(Ids) {
			var messages = getMessagesFromStorage();
			var selectedMessages = [];
			if (Ids != undefined || Ids != null) {
				for (var i = 0; i < Ids.length; i++) {
					for (var j = 0; j < messages.length; j++) {
						if (Ids[i] == messages[j].Id) {
							selectedMessages.push(messages[j]);
							break;
						}
					}
				}
			}

			return selectedMessages;
		}

        /**
         * Get  unread messages
         * @memberof MessageFactory
         * @returns {Array} filteredMessages 
         */
		function getUnreadMessages() {
			var messages = getMessagesFromStorage();
			filteredMessages = [];

			for (var i = 0; i < messages.length; i++) {
				if (!messages[i].ReadDt == null) {
					filteredMessages.push(messages[i])
				}
			}

			return filteredMessages;
		}

        /**
         * Mark the message as read and save it
         * @memberof MessageFactory
         * @param {string} messageId The message identifier
         */
		function markReaden(messageId) {
			// get the Message array from storage
			var messages = getMessagesFromStorage();
			if (messages == null)
				messages = [];

			// find the current Message from the array (if present)
			var arrayLength = messages.length;
			for (var i = 0; i < arrayLength; i++) {
				if (messages[i].Id == messageId) {
					messages[i].ReadDt = new Date();
					break;
				}
			}
			setMessagesToStorage(messages);
		}

        /**
         * Mark the messages as synched and save it
         * @memberof MessageFactory
         * @param {array} readMessages A list of synced messages
         */
		function markReadAsSynched(readMessages) {
		 var messages = getMessagesFromStorage();
		 if (readMessages && messages){
				 var id;
				 for (var i=0;i<readMessages.length;i++){
					 id=readMessages[i].Id;
					 for (var x=0;x<messages.length;x++){
						 if (messages[x].Id===id){
								 messages[x].Synched=true;
						 }
					 }
				 }
				 setMessagesToStorage(messages);
			}
		}

        /**
         * Get the messages that are unsynched and not read and save them
         * @memberof MessageFactory
         * @param {array} readMessages A list of synced messages
         */
		function getUnsynchedReadMessages() {
			var messages = getMessagesFromStorage();
			var data = fromObjectList(messages);
			var filtered = null;

			if (data && data.length > 0){
				filtered = [];
				for (var i=0;i<data.length;i++){
					if (data[i].ReadDt && !data[i].Synched){
						filtered.push({Id: data[i].Id, ReadDt: data[i].ReadDt});
					}
				}
			}
			return filtered;
		}

        /**
         * Store the messages from the sync api
         * @memberof MessageFactory
         * @param {array} readMessages A list of  messages
         */
		function storeMessagesFromServer(messages) {
			if (messages) {
				for (var i = 0; i < messages.length; i++) {
					messages[i].AuthorName=messages[i].AuthorName.replace("GATEWAY\\","");
					messages[i].AuthorName=messages[i].AuthorName.replace("."," ");

					//messages already saved as Read in the server, should not be send to the server again
					if (messages[i].ReadDt)
						messages[i].Synched=true;
					else
						messages[i].Synched=false;
				}
			}
			setMessagesToStorage(messages);
		}

	return service;
	}

})();